<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<ng-template [loadingBlocker]="loadingObservable | async"></ng-template>
<div>{{ appStrings.ACCESS_CODE_ENTER_CODE }}</div>
<form [formGroup]="accessCodeForm">
	<mat-form-field subscriptSizing="dynamic" class="access-code-form-field">
		<input
			matInput
			type="text"
			formControlName="accessCode"
			placeholder="{{ appStrings.ACCESS_CODE_PLACEHOLDER }}"
		/>
	</mat-form-field>
</form>
<button mat-raised-button color="primary" (click)="tryCode()">{{ appStrings.ACCESS_CODE_JOIN }}</button>
